import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type UserTranslationFragment = { id: string, pk: number, originalText: string, currentText: string, entityType: string, entityId: number | null, fieldName: string, language: Types.LanguageEnum, status: Types.TranslationStatusEnum };

export const UserTranslationFragmentDoc = gql`
    fragment UserTranslationFragment on UserTranslationType {
  id
  pk
  originalText
  currentText
  entityType
  entityId
  fieldName
  language
  status
}
    `;